/* eslint-disable */
export function bidHeader(bid) {
  // return registration body
  let body = {
    "amount": bid.amount,
    "hasFinanceProviso": bid.hasFinanceProviso,
    "hasInspectionProviso": bid.hasInspectionProviso,
    "hasNHGProviso": bid.hasNHGProviso,
    "provisoDetails": bid.provisoDetails,
    "requestedDeliveryDate": bid.date,
    "hasAcceptedTermsAndConditions": bid.acceptTermsAndConditions
  };

  if (body) {
    return JSON.stringify(body);
  }
  return {};
}
/* eslint-enable */
